(function (angular) {
    'use strict';

    angular.module('dashboard')

        .component('dashboardMessageTimeline', {
            bindings: {
                data: "<"
            },
            controller: ["$element", "chartFactoryService", function ($element, chartFactoryService) {
                var ctrl = this;

                Chart.pluginService.register(chartFactoryService.fillScatteredTimeScaleDataPlugin);

                ctrl.$onChanges = function (changes) {
                    if (changes.data.currentValue) {
                        ctrl.data = changes.data.currentValue;

                        if (ctrl.line) {
                            ctrl.line.destroy();
                        }

                        ctrl.line = new Chart(ctrl.ctx, {
                            type: "line",
                            data: {
                                datasets: ctrl.data.datasets
                            },
                            options: {
                                plugins: {
                                    datalabels: {
                                        display: false
                                    }
                                },
                                legend: {
                                    display: false,
                                },
                                scales: {
                                    xAxes: [{
                                        type: 'time',
                                        time: {
                                            unit: 'hour',
                                            min: moment().startOf('day').toDate(),
                                            max: moment().endOf('day').toDate(),
                                            fillGapsWithZero: true
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }],
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                            userCallback: function (label, index, labels) {
                                                // when the floored value is the same as the value we have a whole number
                                                if (Math.floor(label) === label) {
                                                    return label;
                                                }
                                            },
                                        },
                                        gridLines: {
                                            display: false
                                        }

                                    }],
                                },
                                responsive: true,
                                title: {
                                    display: false,
                                },
                                tooltips: {
                                    mode: 'index',
                                    intersect: false,
                                    callbacks: {
                                        title: function (tooltipItem, chart) {
                                            if (tooltipItem && tooltipItem[0]) {
                                                tooltipItem = tooltipItem[0];
                                                return moment(tooltipItem.xLabel).format('HH:mm');
                                            }
                                        },
                                    }
                                }
                            }
                        });
                    }
                };

                ctrl.$onInit = function () {
                    var canvas = $element.find("canvas");
                    ctrl.ctx = canvas[0].getContext("2d");
                };
            }],
            template: '<div class="col-md-12 card"><canvas height="100"></canvas></div>'
        });

})(window.angular);